// src/store/reducers/postponedChecksSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    warnedCaseIds: {} // { [caseId]: timestamp }
};

const postponedChecksSlice = createSlice({
    name: 'postponedChecks',
    initialState,
    reducers: {
        markWarned: (state, action) => {
            const caseId = action.payload;
            state.warnedCaseIds[caseId] = Date.now(); // store timestamp
        },
        clearExpiredWarnings: (state, action) => {
            const expiryDuration = action.payload || 30 * 60 * 1000; // default 30 minutes
            
            const now = Date.now();
            for (const [caseId, timestamp] of Object.entries(state.warnedCaseIds)) {
                if (now - timestamp > expiryDuration) {
                    delete state.warnedCaseIds[caseId];
                }
            }
        },
        clearAllWarnings: (state) => {
            state.warnedCaseIds = {};
        }
    }
});

export const { markWarned, clearExpiredWarnings, clearAllWarnings } = postponedChecksSlice.actions;
export default postponedChecksSlice.reducer;